import { animate, useReducedMotion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import { useDentalSectionReady } from "../../hooks/useDentalSectionReveal";

export function DentalStoryCount({ value }: { value: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  const ready = useDentalSectionReady(ref);
  const reducedMotion = useReducedMotion();
  const [display, setDisplay] = useState(value);
  useEffect(() => {
    const match = value.match(/^(\d+)(.*)$/);
    if (!match || reducedMotion) { setDisplay(value); return; }
    const [, digits, suffix] = match;
    if (!ready) { setDisplay(`0${suffix}`); return; }
    const animation = animate(0, Number(digits), {
      duration: 1.4, ease: "easeOut",
      onUpdate: (current) => setDisplay(`${Math.round(current)}${suffix}`),
      onComplete: () => setDisplay(value),
    });
    return () => animation.stop();
  }, [ready, reducedMotion, value]);
  return <span ref={ref} className="inline-grid tabular-nums"><span className="invisible col-start-1 row-start-1" aria-hidden="true">{value}</span><span className="col-start-1 row-start-1" aria-hidden="true">{display}</span><span className="sr-only">{value}</span></span>;
}
